import { datetime } from "../../../../util/library/datetime";
import { SHORT_DATETIME_FORMAT } from "../../../../util/varibles/constants";
import { durationTxt } from "../../../../util/varibles/global";
import { IPause } from "../../../../util/varibles/interface";

export default function PauseView({ data }: { data: IPause }) {
    const { start_time, finish_time = 0, reason } = data;

    return <div className="flex flex-col items-end text-[14px]">
        <div>{datetime(start_time).format(SHORT_DATETIME_FORMAT)}</div>
        <div>{durationTxt(finish_time - start_time)}</div>
        <div className="text-comment">{reason}</div>
        <div>{datetime(finish_time).format(SHORT_DATETIME_FORMAT)}</div>
    </div>
}